import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import qs from 'qs';
import { useHistory } from 'react-router-dom';
import { humanize, titleize } from 'underscore.string';
import { useTranslation } from 'react-i18next';
import { validateCarrierAppointmentDetails } from '../../../utils/AppointmentWebAPIUtils';
import CargomaticModal from '../../v2/modal';
import Alert from '../../ui/Alert';
import Spinner from '../../ui/Spinner';
import ProTip from '../../ui/ProTip';
import CargomaticInput from '../../v2/input';
const CarrierValidationModal = ({ show, onHideModal, canCancel }) => {
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        master_bol: '',
        release_code: '',
        container: '',
    });
    const [missingAvailableDate, setMissingAvailableDate] = useState(false);
    const [requestPending, setRequestPending] = useState(false);
    const { t } = useTranslation();
    let history = useHistory();
    function onFormChange(field, value) {
        if (!value || value.length < 4) {
            const error = new Error(t('FIELD_IS_REQUIRED', { field: humanize(field) }));
            setErrors(Object.assign(Object.assign({}, errors), { [field]: error }));
        }
        else {
            setErrors(Object.assign(Object.assign({}, errors), { [field]: undefined }));
        }
        setFormData(Object.assign(Object.assign({}, formData), { [field]: value }));
    }
    function canValidate() {
        if (_.isEmpty(formData)) {
            return false;
        }
        if (errors.container || errors.master_bol || errors.release_code) {
            return false;
        }
        if (!formData.container || !formData.master_bol || !formData.release_code) {
            return false;
        }
        return true;
    }
    async function onSubmit() {
        try {
            setRequestPending(true);
            setMissingAvailableDate(false);
            const { found, shipment: { yard_available_date }, } = await validateCarrierAppointmentDetails(formData);
            if (found) {
                if (!yard_available_date) {
                    setMissingAvailableDate(true);
                }
                else {
                    history.push(`/appointments/new?${qs.stringify(formData)}`);
                }
            }
            setRequestPending(false);
        }
        catch (e) {
            setRequestPending(false);
            console.error(e);
        }
    }
    return (React.createElement(CargomaticModal, { show: show, onHide: onHideModal, title: t('FIND_CONTAINER'), backdrop: "static", footer: null, location: "middle", showCloseButton: canCancel, keyboard: canCancel },
        React.createElement("div", { className: "space-y-4" },
            React.createElement("div", { className: "flex h-24" }, missingAvailableDate ? (React.createElement(Alert, { type: "error" }, t('CONTAINER_NOT_AVAILABLE'))) : (React.createElement(ProTip, { className: "bg-red", message: t('PROVIDE_VALID_DATA_FOR_APPOINTMENT') }))),
            React.createElement("div", { className: "grid grid-cols-2 sm:grid-cols-3 gap-4" },
                React.createElement(CargomaticInput, { className: "", error: errors.container, label: t('CONTAINER_NUMBER_NBR_ASTERICK'), info: t('THE_CONTAINER_NUMBER'), placeholder: t('CONTAINER_NUMBER'), onChange: (value) => onFormChange('container', value), value: formData.container, maxLength: 15 }),
                React.createElement(CargomaticInput, { className: "", error: errors.master_bol, label: t('MASTER_BILL_NBR_ASTERICK'), info: t('THE_MASTER_BILL_NUMBER'), placeholder: t('MASTER_BILL_NUMBER'), onChange: (value) => onFormChange('master_bol', value), value: formData.master_bol, maxLength: 30 }),
                React.createElement(CargomaticInput, { className: "", error: errors.release_code, label: t('PIN_CODE_NBR_ASTERICK'), info: t('PIN_CODE_CONTAINER_INFO'), placeholder: t('PIN_CODE'), onChange: (value) => onFormChange('release_code', value), value: formData.release_code, maxLength: 10 })),
            React.createElement("div", { className: "flex justify-end py-4" },
                canCancel && (React.createElement("button", { className: "button button-secondary", onClick: onHideModal }, titleize(t('CANCEL')))),
                React.createElement("button", { className: "button button-green w-24 h-10", disabled: requestPending || !canValidate(), onClick: onSubmit }, requestPending ? (React.createElement(Spinner, { showMessage: false })) : (titleize(t('VALIDATE'))))))));
};
CarrierValidationModal.propType = {
    canCancel: PropTypes.bool,
};
CarrierValidationModal.defaultProps = {
    canCancel: true,
};
export default CarrierValidationModal;
